import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISanitizeChallengesBody } from './sanitize-challenges-request';
import type { ISanitizeChallengesResponse } from './sanitize-challenges-response';
import { sanitizeChallengesResponseSchema } from './sanitize-challenges-response';

export async function sanitizeChallengesApi(
  body: ISanitizeChallengesBody,
): Promise<IValidatedResponse<ISanitizeChallengesResponse>> {
  return postRequest<ISanitizeChallengesResponse>({
    path: '/sys/challenges/sanitize',
    body,
    schema: sanitizeChallengesResponseSchema,
  });
}
